const getDeployEnv = () => {
  return process.env.DEPLOY_ENV || "local";
};
const getDeployArea = () => {
  return process.env.DEPLOY_AREA || "cn";
};
const getDeployEnvArea = () => {
  const env = getDeployEnv();
  const area = getDeployArea();
  return `${env}_${area}`;
};
export {
  getDeployArea,
  getDeployEnv,
  getDeployEnvArea
};
